export default __webpack_public_path__ + "static/media/dietMentalPhysical.3cb72c04.jpg";